import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

let activeRequests = 0;

// Functional Interceptor per Angular standalone
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Ignora certe richieste (es. refresh token, health check)
  if (shouldSkipLoading(req)) {
    return next(req);
  }

  // Incrementa contatore richieste attive
  activeRequests++;

  // Mostra loading se è la prima richiesta
  if (activeRequests === 1) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      // Decrementa contatore richieste attive
      activeRequests--;

      // Nascondi loading se non ci sono più richieste attive
      if (activeRequests === 0) {
        loadingService.hide();
      }
    })
  );
};

/**
 * Determina se saltare il loading per questa richiesta
 */
function shouldSkipLoading(req: HttpRequest<any>): boolean {
  // Skip loading per refresh token
  if (req.url.includes('/auth/refresh')) {
    return true;
  }

  // Skip loading per health check
  if (req.url.includes('/health')) {
    return true;
  }

  // Skip loading se specificato nell'header
  if (req.headers.get('Skip-Loading') === 'true') {
    return true;
  }

  return false;
}
